<template>
  <div class="layout-topbar">
    <div class="layout-topbar-left">
      
      <router-link :to="isSda ? '/users' : '/'" class="logo-mobile flex align-items-center">
        <img id="app-logo" :src="logoSrc" alt="SMEG CONNECT" :class="{ 'logoImg': isSda }" />
      </router-link>
      <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
          <i class="pi pi-chevron-left"></i>
      </a>

      <app-breadcumbs class="layout-topbar-path"></app-breadcumbs>

      <!-- <LocaleChanger v-if="$config.currentEnv == 'dev'" customclass="w-auto"></LocaleChanger>  -->
      <LocaleChanger customclass="w-auto"></LocaleChanger> 

      <AppMenu :model="menu" :layoutMode="layoutMode" :active="menuActive"
      :mobileMenuActive="staticMenuMobileActive" @menu-click="onMenuClick" @menuitem-click="onMenuItemClick"
      @root-menuitem-click="onRootMenuItemClick" @menu-update="setupMenu"></AppMenu>
      <div class="layout-mask modal-in"></div>
    </div>
  </div>
</template>

<script>
import AppBreadcumbs from "./AppBreadcumbs.vue";
import AppMenu from "./AppMenu.vue";
import Profile from "./components/Profile.vue";
import countries from "./assets/countries.json";
import { useLoginStore } from "./stores/login.js";
import { mapActions, mapState } from "pinia";
import LocaleChanger from "./components/utils/LocaleChanger.vue";
export default {
  components: { AppBreadcumbs, Profile, AppMenu, LocaleChanger },
  name: "AppTopbar",
  emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-button-click", "search-click", "topbar-notification", "topbar-user-menu", "right-menubutton-click"],
  props: {
      topbarNotificationMenuActive: Boolean,
      topbarUserMenuActive: Boolean,
      layoutMode: String,
      menu: Array,
      menuActive: Boolean,
      staticMenuMobileActive: Boolean
  },
  data() {
    return {
      selected: null,
      options: countries,
      selectTenant: null,
      tenants: []
    };
  },
  computed: {
    ...mapState(useLoginStore, ["getAbacConfig", "getTenant"]),
    toggleTenant() {
      if (this.tenants.length === 1) {
        return true;
      } else {
        return false;
      }
    },
    logoSrc() {
      return this.isSda ? '/images/assistant_logo.svg' : '/images/connect_logo.png';
    },
    isSda() {
      return this.getAbacConfig?.role_def?.subtenant?.length==1 && this.getAbacConfig?.role_def?.subtenant?.[0] === 'sda';
    }
  },
  methods: {
    ...mapActions(useLoginStore, ["setTenant", "setAbacConfig"]),
    async setNewTenant() {
      await this.setTenant(this.selectTenant);
      await this.setAbacConfig(this.getTenant);

      if (this.$route.name === "Appliances") {
        location.reload();
      } else {
        this.$router.push({
          name: "Appliances",
        });
      }

    },
    onMenuClick(event) {
        this.$emit("menu-click", event);
    },
    onMenuItemClick(event) {
        this.$emit("menuitem-click", event);
    },
    onRootMenuItemClick(event) {
        this.$emit("root-menuitem-click", event);
    },
    onMenuButtonClick(event) {
        this.$emit("menu-button-click", event);
    },
    onSearchClick(event) {
        this.$emit("search-click", event);
    },
    onTopbarNotificationMenuButtonClick(event) {
        this.$emit("topbar-notification", event);
    },
    onTopbarUserMenuButtonClick(event) {
        this.$emit("topbar-user-menu", event);
    },
    onRightMenuClick(event) {
      this.$emit("right-menubutton-click", event);
    },
    isMobile() {
      return window.innerWidth <= 1091;
    },
    setupMenu() {
      this.$emit("menu-update");
    }
  },
  mounted() {
    // if (this.getAbacConfig) {
    //   let tenant_abac = (this.getAbacConfig).tenants; XXX_TENANT_XXX
    //   for (let i = 0; i < tenant_abac.length; i++) {
    //     let obj = {
    //       label: tenant_abac[i],
    //       key: tenant_abac[i]
    //     }
    //     this.tenants.push(obj);
    //   }
    // }

    // this.selectTenant = { label: this.getTenant, key: this.getTenant };
  }
};
</script>

<style>
  .logoImg {
    filter: invert(100%);
  }
</style>
